/**
 * Pictogrammes des compteurs de jeu (PV du parcours, éclats, vague, jokers, round).
 *
 * Décoratifs : le libellé du compteur reste dans le DOM (masqué visuellement sur les écrans les
 * plus courts) et c'est lui que lisent les technologies d'assistance. Formes simples tracées ici,
 * aucune police d'icônes ni bibliothèque tierce.
 */
export type CompteurHud = 'pv' | 'eclats' | 'vague' | 'jokers' | 'round';

const TRACES: Readonly<Record<CompteurHud, string>> = {
  /** Cœur : la vie du parcours. */
  pv: 'M12 20.5 4.2 12.9a4.8 4.8 0 0 1 6.8-6.8L12 7.1l1-1a4.8 4.8 0 0 1 6.8 6.8Z',
  /** Éclat de cristal : la monnaie de la run. */
  eclats: 'M12 2.5 18.5 9 12 21.5 5.5 9Z',
  /** Trois vagues. */
  vague:
    'M3 8.5c2.2 0 2.2-2 4.5-2s2.2 2 4.5 2 2.2-2 4.5-2 2.2 2 4.5 2M3 13c2.2 0 2.2-2 4.5-2s2.2 2 4.5 2 2.2-2 4.5-2 2.2 2 4.5 2M3 17.5c2.2 0 2.2-2 4.5-2s2.2 2 4.5 2 2.2-2 4.5-2 2.2 2 4.5 2',
  /** Étoile à quatre branches : le joker de pose. */
  jokers:
    'M12 2.5c.9 5 2.5 6.6 7.5 7.5-5 .9-6.6 2.5-7.5 7.5-.9-5-2.5-6.6-7.5-7.5 5-.9 6.6-2.5 7.5-7.5Z',
  /** Boucle : le round du mode illimité. */
  round: 'M19 12a7 7 0 1 1-2.05-4.95M19 4.5V9h-4.5',
};

/** Tracés au trait (les autres sont pleins). */
const AU_TRAIT: ReadonlySet<CompteurHud> = new Set(['vague', 'round']);

export function IconeHud({ compteur }: { readonly compteur: CompteurHud }) {
  const trait = AU_TRAIT.has(compteur);
  return (
    <svg
      className={`icone-hud icone-hud--${compteur}`}
      viewBox="0 0 24 24"
      width="16"
      height="16"
      aria-hidden="true"
      focusable="false"
    >
      <path
        d={TRACES[compteur]}
        fill={trait ? 'none' : 'currentColor'}
        stroke={trait ? 'currentColor' : 'none'}
        strokeWidth={trait ? 2 : 0}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
